import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconEndChat",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.5 2a.5.5 0 0 0-.5.5v6.793l1.147-1.146A.5.5 0 0 1 3.5 8H5a.5.5 0 1 1 0 1H3.707l-1.853 1.854A.5.5 0 0 1 1 10.501v-8A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v2.75a.5.5 0 1 1-1 0V2.5a.5.5 0 0 0-.5-.5h-7Zm6.308 4.5a.5.5 0 0 1 .5.5v2.41l.955-.955a.5.5 0 1 1 .707.707L9.162 10.97a.5.5 0 0 1-.707 0L6.647 9.162a.5.5 0 1 1 .707-.707l.954.955V7a.5.5 0 0 1 .5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function h(e, u, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--end-chat"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "End Chat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", h]]);
export {
  C as default
};
//# sourceMappingURL=end-chat.js.map
